import { AppThunk } from '../../types';
import {
  setTitleReportFetchStatusAction,
  setTitleReportErrorAction,
  setTitleReportAction,
  setTitleReportExistAction,
} from './reducer';
import { getTitleReportAsync } from 'API/order/TitleReportsAPI';
import { createFetchedSuccess, createFetchedWithError, createFetchInProgress } from 'types/rest/IFetchStatus';
import {
  createDefaultTitleReportData,
  ITitleReportData,
} from '../../../ui-toolkit/orders/interfaces/titleReport/ITitleReport';

export const getTitleReport =
  (orderId: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setTitleReportErrorAction(null));
      dispatch(setTitleReportFetchStatusAction(createFetchInProgress()));
      const response: ITitleReportData = await getTitleReportAsync(orderId);
      dispatch(setTitleReportAction(response));
      dispatch(setTitleReportExistAction({ orderId, value: true }));

      dispatch(setTitleReportFetchStatusAction(createFetchedSuccess()));
    } catch (e: any) {
      if (!!e.response && !!e.response.status && e.response.status === 404) {
        dispatch(setTitleReportAction(createDefaultTitleReportData()));
        dispatch(setTitleReportExistAction({ orderId, value: false }));
        dispatch(setTitleReportFetchStatusAction(createFetchedSuccess()));
      } else {
        dispatch(setTitleReportFetchStatusAction(createFetchedWithError()));
        dispatch(setTitleReportAction(e.message));
      }
    }
  };
